// extracted by mini-css-extract-plugin
export var footer = "_ni-0";
export var inherit = "_ni-1";
export var input = "_ni-2";
export var modalContent = "_ni-3";
export var quillEditor = "_ni-4";
export var subtitle = "_ni-5";